export type TResultAsset = string

//TODO - implement a class representing our rendered asset

export enum ResultAssetType {
    None = 0,
    Cubemap = 1,
    Image = 2,
    Video = 3,
    VirtualTourPlayerJson = 100
};

export enum ResultAssetResolution {
    Original = 0,
    K1 = 1,
    K2 = 2,
    K4 = 4,
    K6 = 6
};